import React from 'react';
import PropTypes from 'prop-types';

import createStyle from 'shared-utils/src/createStyle';

import LoginAdBoost from 'shared-vectors/icons/LoginAdBoost';
import LoginAddNotes from 'shared-vectors/icons/LoginAddNotes';
import LoginCallAssistance from 'shared-vectors/icons/LoginCallAssistance';
import LoginGoToChronology from 'shared-vectors/icons/LoginGoToChronology';
import LoginPublishAd from 'shared-vectors/icons/LoginPublishAd';
import LoginResearchNotifications from 'shared-vectors/icons/LoginResearchNotifications';
import LoginSaveFavourites from 'shared-vectors/icons/LoginSaveFavourites';
import LoginSyncDevices from 'shared-vectors/icons/LoginSyncDevices';
import { Icon } from 'shared-vectors';

import ModalContainer from '../../../../ModalContainer';
import ModalHeader from '../../../../ModalHeader';
import ModalBody from '../../../../ModalBody';

import Grid from '../../../../Grid';
import GridItem from '../../../../GridItem';

import style, { mainCls } from './style';

const useStyles = createStyle(style);

const sections = [{
  title: 'Se cerchi casa potrai:',
  items: [{
    icon: <Icon name={LoginResearchNotifications} illustration width="24px" height="24px" />,
    text: <><span className="tp-w--l">Salvare le tue ricerche</span> e <span className="tp-w--l">ricevere notifiche</span> per ogni nuovo annuncio</>,
  }, {
    icon: <Icon name={LoginSaveFavourites} illustration width="24px" height="24px" />,
    text: <><span className="tp-w--l">Salvare i tuoi immobili preferiti</span></>,
  }, {
    icon: <Icon name={LoginAddNotes} illustration width="24px" height="24px" />,
    text: <><span className="tp-w--l">Aggiungere note personali</span></>,
  }, {
    icon: <Icon name={LoginGoToChronology} illustration width="24px" height="24px" />,
    text: <><span className="tp-w--l">Accedere alla cronologia</span> delle tue ricerche e degli immobili</>,
  }, {
    icon: <Icon name={LoginSyncDevices} illustration width="24px" height="24px" />,
    text: <><span className="tp-w--l">Tutto sincronizzato!</span> Ritrovi le tue attività e i tuoi salvataggi su qualsiasi dispositivo</>,
  }],
}, {
  title: 'Se vuoi vendere o affittare potrai:',
  items: [{
    icon: <Icon name={LoginPublishAd} illustration width="24px" height="24px" />,
    text: <><span className="tp-w--l">Pubblicare il tuo annuncio</span> in modo semplice e veloce</>,
  }, {
    icon: <Icon name={LoginAdBoost} illustration width="24px" height="24px" />,
    text: <><span className="tp-w--l">Vendere e affittare prima</span> grazie ai pacchetti di visibilità per ogni esigenza</>,
  }, {
    icon: <Icon name={LoginCallAssistance} illustration width="24px" height="24px" />,
    text: <>Ricevere <span className="tp-w--l">assistenza professionale dedicata</span></>,
  }],
}]

const LoginPresentation = ({
  version,
  showPresentationLayer,
  togglePresentationLayer,
}) => {
  const cls = useStyles();

  return (
    <div className={`${cls[mainCls]}${showPresentationLayer ? ' _up': ''} c-bg--w is-anim`}>
      <ModalContainer>
        <ModalHeader
          compact
          title={<>I vantaggi di <span className="c-txt--primary">My</span>Casa</>}
          backButton={{ action: () => togglePresentationLayer() }}
          version={version}
        />
        <ModalBody>
          {sections.map((section) => (
            <>
              <p className={`${cls[`${mainCls}__tit`]} pt--m pb--m tp-w--l c-txt--f0`}>
                {section.title}
              </p>
              {section.items.map((item => (
                <Grid align="center" className={cls[`${mainCls}__item`]}>
                <GridItem behavior="fixed">
                  <Grid justify="center" align="center" className={`${cls[`${mainCls}__icon`]} c-txt--f0 c-bg--f4 b-r--pill`}>
                    {item.icon}
                  </Grid>
                </GridItem>
                <GridItem className={`${cls[`${mainCls}__txt`]} pl--m tp-s--l c-txt--f0`}>
                  {item.text}
                </GridItem>
              </Grid>
              )))}
            </>
          ))}
        </ModalBody>
      </ModalContainer>
    </div>
  );
};

export default LoginPresentation;

LoginPresentation.propTypes = {
  modalData: PropTypes.instanceOf(Object),
};

LoginPresentation.defaultProp = {
  modalData: {},
};
